import styled from '@emotion/styled';

import Link from '@skippay/core/components/Link';
import { color, fontSize, transition } from '@skippay/core/styles/variables';


export const SDescription = styled.div`
  display: none;
  padding: 1.5rem;
  position: absolute;
  background: ${color('white')};
  top: 0;
  left: 50%;
  width: 50%;
  opacity: 0;
  transition: opacity ${transition('slower')};
  @media screen and (min-width: 1160px) {
    display: block;
  }
`;
export const SSubmenuLink = styled.li`
  font-size: ${fontSize('content')};
  &:first-of-type  ${SDescription}{
   opacity: 1;
  }
`

export const SLink = styled(Link)`
  display: block;
  padding: .25rem 0 !important;

  &.isActive {
    color: ${color('blue-500')}
  }

  &:hover + ${SDescription} {
    opacity: 1;
  }
`;
